import React from "react";
import SentimentalAnalysis from "./SentimentalAnalysis";
import AIInsights from "./AIInsights";
import TrendingTweets from "./TrendingTweets";

const MarketInsightsPanel = () => {
    return (
        <div className="p-4 grid gap-4 md:grid-cols-2 xl:grid-cols-3 ">
            <div className="bg-zinc-900 border border-indigo-600 rounded-xl shadow-lg p-4">
                <AIInsights />
            </div>
            <div className="bg-zinc-900 border border-fuchsia-700 rounded-xl shadow-lg p-4">
                <SentimentalAnalysis />
            </div>
            <div className="bg-zinc-900 border border-teal-600 rounded-xl shadow-lg p-4">
                <TrendingTweets />
            </div>
        </div>
    );
};

export default MarketInsightsPanel;
